// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.contSearchHost{
    position: absolute;
    /* background-color: aliceblue; */
    height: auto;
    width: auto;

    z-index: 2;

    display: block;
    justify-content: left;
    align-items: center;
    top: 13%;
    padding-left: 3%;
}


.container-searchHost {
    position: relative;
    box-sizing: border-box;
    width: -moz-fit-content;
    width: fit-content;
  }
  .container-searchHost-list{
    /* background-color: #2c305cbd; */
    width: 230px;
    height: auto;
    box-sizing: border-box;
    position: relative;
    display: flex;
    justify-content: center;
    max-height: 150px;

    font-size: medium;
  }
  .container-searchHost-list.large{
    width: 650px;
    font-size: x-small;

  }
  .compact-searchHost-list{
    
    width: 180px;
    height: auto;
    box-sizing: border-box;
    position: relative;
    display: block;
    overflow: scroll;
    border: 1px solid rgba(240, 248, 255, 0.575) !important;
    border-radius: 5px;
  }

  .compact-searchHost-list.large{
    width: 650px;
  }
  .cont-row-searchHost-txt{
    display: flex;
    justify-content: center;
  }

  .row-searchHost-list{
    background-color: var(--white-color);
   
position: relative;
display: flex;
justify-content: center;
align-items: center;
width: 100%;
height: 30px;
/* border-bottom: 1px solid rgba(128, 128, 128, 0.452) ; */
color: var(--second-color);
  }
  .row-searchHost-list:hover{
    background-color: #80bdff;
    cursor: pointer;
    color: var(--main-color);
  }
.row-searchHost-list-error{
    background-color: #f9aeae;
   
position: relative;
display: flex;
justify-content: center;
align-items: center;
width: 100%;
height: 30px;
/* border-bottom: 1px solid rgba(128, 128, 128, 0.452) ; */
color: var(--main-color);
  }
.row-searchHost-list-error:hover{
    background-color: #f79090;
    cursor: pointer;
    
  }
  .ip-row-searchHost{
    color: var(--txt-color);
  }
  .row-searchHost-list:hover .ip-row-searchHost {
    color: var(--txt-color);
  }

  .mainbox-searchHost {
    box-sizing: border-box;
    position: relative;
    width: 230px;
    height: 40px;
    display: flex;
    flex-direction: row-reverse;
    align-items: center;
    justify-content: center;
    /* border-radius: 160px; */
    border-radius: var(--border-radios-small);
    background-color: var(--white-color);
    /* background-color: #404040e5; */
    transition: all 0.3s ease;
    box-shadow: 3px 3px 10px rgba(67, 67, 67, 0.4);
  border: 1px solid var(--main-color) 
  }
  
  .checkbox-searchHost:focus {
    border: none;
    outline: none;
  }
  
  .checkbox-searchHost:checked {

    right: 10px !important;
    left: unset;

  }
  
  .checkbox-searchHost:checked ~ .mainbox-searchHost {
    width: 40px;
    border-radius: 160px; 
  }
  .checkbox-searchHost:checked ~ .container-searchHost-list {
    display: none;
  }
  
  .checkbox-searchHost:checked ~ .mainbox-searchHost .search_input-searchHost {
    width: 0;
    height: 0px;
  }
  
  .checkbox-searchHost:checked ~ .mainbox-searchHost .iconcontainer-searchHost {
    padding-right: 8px;
  }
  
  .checkbox-searchHost {
    box-sizing: border-box;
    width: 30px;
    height: 30px;
    position: absolute;

    /* right: 17px; */
    left: 185px;

    top: 10px;
    z-index: 9;
    cursor: pointer;
    appearance: none;
  }
  
  .search_input-searchHost {
    box-sizing: border-box;
    height: 100%;
    width: 170px;
    background-color: transparent;
    border: none;
    outline: none;
    padding-bottom: 4px;
    padding-left: 10px;
    font-size: var(--font-size-small);
    color: var(--txt-color);
    transition: all 0.3s ease;
    font-family: "Roboto" !important
  }
  
  .search_input-searchHost::placeholder {
    color: var(--txt-color-low);
    font-size: var(--font-size-small);
  }
  
  .iconcontainer-searchHost {
    box-sizing: border-box;
    padding-top: 5px;
    width: -moz-fit-content;
    width: fit-content;
    transition: all 0.3s ease;
  }
  
  .search_icon-searchHost {
    box-sizing: border-box;
    fill: var(--second-color);
    font-size: 1.3em;
  }


  .cont-findHost {
    width: 120px;
  height: 15px;
  position: relative;

  background-color: rgb(252, 255, 153);

  color: #34373c;
  font-size: small;
  border-radius: 100px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: bold;
  }

  .findHost-txt{
    width: 85%;
    height: 100%;
    display: flex;
  justify-content: center;
  align-items: center;
  }
  .findHost-close{
    width: 15%;
    height: 100%;
    background-color: #ff4b4b;
    display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 0px 100px 100px 0px ;
  }
  .findHost-close:hover{
    cursor: pointer;
  }

  .row-close-list{
    color: red;
  }`, "",{"version":3,"sources":["webpack://./src/components/styles/SearchHost.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,iCAAiC;IACjC,YAAY;IACZ,WAAW;;IAEX,UAAU;;IAEV,cAAc;IACd,qBAAqB;IACrB,mBAAmB;IACnB,QAAQ;IACR,gBAAgB;AACpB;;;AAGA;IACI,kBAAkB;IAClB,sBAAsB;IACtB,uBAAkB;IAAlB,kBAAkB;EACpB;EACA;IACE,iCAAiC;IACjC,YAAY;IACZ,YAAY;IACZ,sBAAsB;IACtB,kBAAkB;IAClB,aAAa;IACb,uBAAuB;IACvB,iBAAiB;;IAEjB,iBAAiB;EACnB;EACA;IACE,YAAY;IACZ,kBAAkB;;EAEpB;EACA;;IAEE,YAAY;IACZ,YAAY;IACZ,sBAAsB;IACtB,kBAAkB;IAClB,cAAc;IACd,gBAAgB;IAChB,uDAAuD;IACvD,kBAAkB;EACpB;;EAEA;IACE,YAAY;EACd;EACA;IACE,aAAa;IACb,uBAAuB;EACzB;;EAEA;IACE,oCAAoC;;AAExC,kBAAkB;AAClB,aAAa;AACb,uBAAuB;AACvB,mBAAmB;AACnB,WAAW;AACX,YAAY;AACZ,0DAA0D;AAC1D,0BAA0B;EACxB;EACA;IACE,yBAAyB;IACzB,eAAe;IACf,wBAAwB;EAC1B;AACF;IACI,yBAAyB;;AAE7B,kBAAkB;AAClB,aAAa;AACb,uBAAuB;AACvB,mBAAmB;AACnB,WAAW;AACX,YAAY;AACZ,0DAA0D;AAC1D,wBAAwB;EACtB;AACF;IACI,yBAAyB;IACzB,eAAe;;EAEjB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,uBAAuB;EACzB;;EAEA;IACE,sBAAsB;IACtB,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,aAAa;IACb,2BAA2B;IAC3B,mBAAmB;IACnB,uBAAuB;IACvB,0BAA0B;IAC1B,yCAAyC;IACzC,oCAAoC;IACpC,iCAAiC;IACjC,yBAAyB;IACzB,8CAA8C;EAChD;EACA;;EAEA;IACE,YAAY;IACZ,aAAa;EACf;;EAEA;;IAEE,sBAAsB;IACtB,WAAW;;EAEb;;EAEA;IACE,WAAW;IACX,oBAAoB;EACtB;EACA;IACE,aAAa;EACf;;EAEA;IACE,QAAQ;IACR,WAAW;EACb;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,sBAAsB;IACtB,WAAW;IACX,YAAY;IACZ,kBAAkB;;IAElB,iBAAiB;IACjB,WAAW;;IAEX,SAAS;IACT,UAAU;IACV,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,sBAAsB;IACtB,YAAY;IACZ,YAAY;IACZ,6BAA6B;IAC7B,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,kBAAkB;IAClB,iCAAiC;IACjC,uBAAuB;IACvB,yBAAyB;IACzB;EACF;;EAEA;IACE,2BAA2B;IAC3B,iCAAiC;EACnC;;EAEA;IACE,sBAAsB;IACtB,gBAAgB;IAChB,uBAAkB;IAAlB,kBAAkB;IAClB,yBAAyB;EAC3B;;EAEA;IACE,sBAAsB;IACtB,yBAAyB;IACzB,gBAAgB;EAClB;;;EAGA;IACE,YAAY;EACd,YAAY;EACZ,kBAAkB;;EAElB,oCAAoC;;EAEpC,cAAc;EACd,gBAAgB;EAChB,oBAAoB;EACpB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;EACjB;;EAEA;IACE,UAAU;IACV,YAAY;IACZ,aAAa;EACf,uBAAuB;EACvB,mBAAmB;EACnB;EACA;IACE,UAAU;IACV,YAAY;IACZ,yBAAyB;IACzB,aAAa;EACf,uBAAuB;EACvB,mBAAmB;EACnB,mCAAmC;EACnC;EACA;IACE,eAAe;EACjB;;EAEA;IACE,UAAU;EACZ","sourcesContent":[".contSearchHost{\r\n    position: absolute;\r\n    /* background-color: aliceblue; */\r\n    height: auto;\r\n    width: auto;\r\n\r\n    z-index: 2;\r\n\r\n    display: block;\r\n    justify-content: left;\r\n    align-items: center;\r\n    top: 13%;\r\n    padding-left: 3%;\r\n}\r\n\r\n\r\n.container-searchHost {\r\n    position: relative;\r\n    box-sizing: border-box;\r\n    width: fit-content;\r\n  }\r\n  .container-searchHost-list{\r\n    /* background-color: #2c305cbd; */\r\n    width: 230px;\r\n    height: auto;\r\n    box-sizing: border-box;\r\n    position: relative;\r\n    display: flex;\r\n    justify-content: center;\r\n    max-height: 150px;\r\n\r\n    font-size: medium;\r\n  }\r\n  .container-searchHost-list.large{\r\n    width: 650px;\r\n    font-size: x-small;\r\n\r\n  }\r\n  .compact-searchHost-list{\r\n    \r\n    width: 180px;\r\n    height: auto;\r\n    box-sizing: border-box;\r\n    position: relative;\r\n    display: block;\r\n    overflow: scroll;\r\n    border: 1px solid rgba(240, 248, 255, 0.575) !important;\r\n    border-radius: 5px;\r\n  }\r\n\r\n  .compact-searchHost-list.large{\r\n    width: 650px;\r\n  }\r\n  .cont-row-searchHost-txt{\r\n    display: flex;\r\n    justify-content: center;\r\n  }\r\n\r\n  .row-searchHost-list{\r\n    background-color: var(--white-color);\r\n   \r\nposition: relative;\r\ndisplay: flex;\r\njustify-content: center;\r\nalign-items: center;\r\nwidth: 100%;\r\nheight: 30px;\r\n/* border-bottom: 1px solid rgba(128, 128, 128, 0.452) ; */\r\ncolor: var(--second-color);\r\n  }\r\n  .row-searchHost-list:hover{\r\n    background-color: #80bdff;\r\n    cursor: pointer;\r\n    color: var(--main-color);\r\n  }\r\n.row-searchHost-list-error{\r\n    background-color: #f9aeae;\r\n   \r\nposition: relative;\r\ndisplay: flex;\r\njustify-content: center;\r\nalign-items: center;\r\nwidth: 100%;\r\nheight: 30px;\r\n/* border-bottom: 1px solid rgba(128, 128, 128, 0.452) ; */\r\ncolor: var(--main-color);\r\n  }\r\n.row-searchHost-list-error:hover{\r\n    background-color: #f79090;\r\n    cursor: pointer;\r\n    \r\n  }\r\n  .ip-row-searchHost{\r\n    color: var(--txt-color);\r\n  }\r\n  .row-searchHost-list:hover .ip-row-searchHost {\r\n    color: var(--txt-color);\r\n  }\r\n\r\n  .mainbox-searchHost {\r\n    box-sizing: border-box;\r\n    position: relative;\r\n    width: 230px;\r\n    height: 40px;\r\n    display: flex;\r\n    flex-direction: row-reverse;\r\n    align-items: center;\r\n    justify-content: center;\r\n    /* border-radius: 160px; */\r\n    border-radius: var(--border-radios-small);\r\n    background-color: var(--white-color);\r\n    /* background-color: #404040e5; */\r\n    transition: all 0.3s ease;\r\n    box-shadow: 3px 3px 10px rgba(67, 67, 67, 0.4);\r\n  border: 1px solid var(--main-color) \r\n  }\r\n  \r\n  .checkbox-searchHost:focus {\r\n    border: none;\r\n    outline: none;\r\n  }\r\n  \r\n  .checkbox-searchHost:checked {\r\n\r\n    right: 10px !important;\r\n    left: unset;\r\n\r\n  }\r\n  \r\n  .checkbox-searchHost:checked ~ .mainbox-searchHost {\r\n    width: 40px;\r\n    border-radius: 160px; \r\n  }\r\n  .checkbox-searchHost:checked ~ .container-searchHost-list {\r\n    display: none;\r\n  }\r\n  \r\n  .checkbox-searchHost:checked ~ .mainbox-searchHost .search_input-searchHost {\r\n    width: 0;\r\n    height: 0px;\r\n  }\r\n  \r\n  .checkbox-searchHost:checked ~ .mainbox-searchHost .iconcontainer-searchHost {\r\n    padding-right: 8px;\r\n  }\r\n  \r\n  .checkbox-searchHost {\r\n    box-sizing: border-box;\r\n    width: 30px;\r\n    height: 30px;\r\n    position: absolute;\r\n\r\n    /* right: 17px; */\r\n    left: 185px;\r\n\r\n    top: 10px;\r\n    z-index: 9;\r\n    cursor: pointer;\r\n    appearance: none;\r\n  }\r\n  \r\n  .search_input-searchHost {\r\n    box-sizing: border-box;\r\n    height: 100%;\r\n    width: 170px;\r\n    background-color: transparent;\r\n    border: none;\r\n    outline: none;\r\n    padding-bottom: 4px;\r\n    padding-left: 10px;\r\n    font-size: var(--font-size-small);\r\n    color: var(--txt-color);\r\n    transition: all 0.3s ease;\r\n    font-family: \"Roboto\" !important\r\n  }\r\n  \r\n  .search_input-searchHost::placeholder {\r\n    color: var(--txt-color-low);\r\n    font-size: var(--font-size-small);\r\n  }\r\n  \r\n  .iconcontainer-searchHost {\r\n    box-sizing: border-box;\r\n    padding-top: 5px;\r\n    width: fit-content;\r\n    transition: all 0.3s ease;\r\n  }\r\n  \r\n  .search_icon-searchHost {\r\n    box-sizing: border-box;\r\n    fill: var(--second-color);\r\n    font-size: 1.3em;\r\n  }\r\n\r\n\r\n  .cont-findHost {\r\n    width: 120px;\r\n  height: 15px;\r\n  position: relative;\r\n\r\n  background-color: rgb(252, 255, 153);\r\n\r\n  color: #34373c;\r\n  font-size: small;\r\n  border-radius: 100px;\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  font-weight: bold;\r\n  }\r\n\r\n  .findHost-txt{\r\n    width: 85%;\r\n    height: 100%;\r\n    display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  }\r\n  .findHost-close{\r\n    width: 15%;\r\n    height: 100%;\r\n    background-color: #ff4b4b;\r\n    display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  border-radius: 0px 100px 100px 0px ;\r\n  }\r\n  .findHost-close:hover{\r\n    cursor: pointer;\r\n  }\r\n\r\n  .row-close-list{\r\n    color: red;\r\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
